"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DateFormatter = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DateFormatter = function DateFormatter(_ref) {
  var children = _ref.children;

  if (typeof children === 'string') {
    // Server generating timestamp is using CDT/CST timezone
    // moment.parseZone is giving weird inconsistent behavior and parsing
    // the date to the local browser's time zone even when using parseZone()
    var timestampSplit = children.split('-');
    var day = timestampSplit[2].split('T')[0];
    var month = timestampSplit[1] - 1; // zero based index

    var year = timestampSplit[0];
    var time = timestampSplit[2].split('T')[1];
    var hour = time.split(':')[0];
    var minutes = time.split(':')[1];
    var aa = 'AM';

    if (Number(hour) > 12) {
      hour = Number(hour) - 12;

      if (hour === 12) {
        aa = 'AM';
      } else {
        aa = 'PM';
      }

      hour = hour.toString(10).length < 2 ? "0".concat(hour.toString(10)) : hour;
    } else if (Number(hour) === 12) {
      aa = 'PM';
    } // We use the Date() object to extract the correct month abbreviation


    var date = new Date(year, month, day);
    var monthFormat = date.toDateString().split(' ')[1];
    var rawDate = "".concat(monthFormat, " ").concat(day, ", ").concat(hour, ":").concat(minutes, " ").concat(aa);
    return /*#__PURE__*/_react.default.createElement("span", null, " ", rawDate, " ");
  }

  if (children) {
    return children;
  }

  return /*#__PURE__*/_react.default.createElement("span", null, "\xA0");
};

exports.DateFormatter = DateFormatter;
DateFormatter.propTypes = {
  children: _propTypes.default.any
};
var _default = DateFormatter;
exports.default = _default;